import { browserHistory } from "react-router";

const isIEBrowser = () => {
  let isIE = false;

  if (window && window.navigator) {
    isIE = window.navigator.userAgent.indexOf("MSIE ") > 0 ? true : false;
  }

  return isIE;
};

export const changeLocation = url => {
  if (isIEBrowser() === true) {
    window.location.href = url;
  } else {
    browserHistory.push(url);
  }
};

export const goBack = () => {
  if (isIEBrowser() === true) {
    window.history.go(-1);
  } else {
    browserHistory.goBack();
  }
};



// WEBPACK FOOTER //
// ./src/api/Location.js